const ITEMS = [
  "TRANSPARENT REPUTATION",
  "REAL REVIEWS & ENDORSEMENTS",
  "RANK POSITION IS NOT REPUTATION",
  "HIGHRANK SCORE / 0–100",
  "BOOST FOR VISIBILITY",
  "FOUNDER-FIRST LEADERBOARD",
  "NEW — DISCOVER FEATURED BUSINESSES",
  "INLINE VIDEO CARDS",
  "GET YOUR BUSINESS FEATURED",
  "SHARE CARDS WITH BRANDED PREVIEW",
];

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/5 bg-[#070706] py-3 select-none">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {ITEMS.map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="font-display text-xl sm:text-2xl tracking-[0.2em] text-slate-600 px-8">{item}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
